<template>
  <span v-if="!to">
    <slot />
  </span>

  <a
    v-else-if="isAnchor(to)"
    v-scroll-to="{el:isAnchor(to), offset: isMobile ? 0 : -60}"
    :href="isAnchor(to)"
    class="cursor-pointer"
    @click="$emit('click', $event)"
  >
    <slot />
  </a>

  <a
    v-else-if="to.startsWith('http')"
    :href="to"
    rel="nofollow noopener"
    @click="$emit('click', $event)"
  >
    <slot />
  </a>

  <a
    v-else-if="to.startsWith('tel:') || to.startsWith('mailto:')"
    href="#"
    @click.prevent="special(to)"
  >
    <slot />
  </a>

  <a v-else :href="to" @click="internal($event)">
    <slot />
  </a>
</template>

<script>import { useWithinBreakpoint } from '@/hooks/breakpoints';

export default {
  props: {
    to: { type: String, default: null },
  },
  emits: ['click'],
  setup() {
    return {
      isMobile: useWithinBreakpoint('sm'),
      isTablet: useWithinBreakpoint('md'),
    };
  },
  methods: {
    isAnchor(to) {
      if (to.startsWith('#')) return to;
      return false;
    },
    special(to) {
      this.$emit('click');
      window.location.href = to.replace(/ /g, '');
    },
    internal(e) {
      this.$emit('click', e);
      if (e.which === 2 || e.button === 4 || e.ctrlKey || e.metaKey) return;
      if (e.defaultPrevented) return;
      e.preventDefault();
      this.$store.dispatch('router/push', { uri: this.to });
    },
  },
};
</script>
